// Versión de la aplicación — actualizar manualmente antes de cada release
export const APP_VERSION = '1.0.0'
